var map = {
	"./404.svg": "0150",
	"./bug.svg": "6498",
	"./chart.svg": "9062",
	"./clipboard.svg": "07e1",
	"./component.svg": "c8e7",
	"./dashboard.svg": "50b0",
	"./documentation.svg": "501b",
	"./drag.svg": "4644",
	"./edit.svg": "6534",
	"./email.svg": "62d6",
	"./example.svg": "61d5",
	"./excel.svg": "09d3",
	"./exit-fullscreen.svg": "2552",
	"./eye-open.svg": "9d50",
	"./eye.svg": "3e4a",
	"./form.svg": "280d",
	"./fullscreen.svg": "b43d",
	"./guide 2.svg": "3774",
	"./guide.svg": "f10e",
	"./icon.svg": "913d",
	"./international.svg": "c4e2",
	"./language.svg": "8767",
	"./link.svg": "1770",
	"./list.svg": "7aea",
	"./lock.svg": "725b",
	"./message.svg": "618b",
	"./money.svg": "06b6",
	"./nested.svg": "60f5",
	"./outcome.svg": "db3d",
	"./password.svg": "6842",
	"./pdf.svg": "e8c6",
	"./people.svg": "da3e",
	"./peoples.svg": "0427",
	"./ptime.svg": "fe8e",
	"./qq.svg": "9696",
	"./search.svg": "2896",
	"./shopping.svg": "7f5e",
	"./size.svg": "7067",
	"./star.svg": "ba70",
	"./tab.svg": "b9bc",
	"./table.svg": "4422",
	"./theme.svg": "b2d9",
	"./tree-table.svg": "da3c",
	"./tree.svg": "e76a",
	"./user.svg": "7e2c",
	"./wechat.svg": "791c",
	"./zip.svg": "8dd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d9c";